import { Point, Rectangle, Vector } from "../../../../domain/drawing";
import store from "../../../../store";
import { StandardTransformer } from "./StandardTransformer";

export class GridTransformer extends StandardTransformer {
  protected resizeToTop(source: Rectangle, pointer: Point): Rectangle {
    const resized = super.resizeToTop(source, pointer);
    const offset = this.toOffset(resized);
    resized.size.height += offset.y;
    resized.topLeft.y -= offset.y;
    return resized;
  }

  protected resizeToLeft(source: Rectangle, pointer: Point): Rectangle {
    const resized = super.resizeToLeft(source, pointer);
    const offset = this.toOffset(resized);
    resized.size.width += offset.x;
    resized.topLeft.x -= offset.x;
    return resized;
  }

  protected resizeToRight(source: Rectangle, pointer: Point): Rectangle {
    const resized = super.resizeToRight(source, pointer);
    const offset = this.toOffset(resized);
    resized.size.width += offset.x;
    return resized;
  }

  protected resizeToBottom(source: Rectangle, pointer: Point): Rectangle {
    const resized = super.resizeToBottom(source, pointer);
    const offset = this.toOffset(resized);
    resized.size.height += offset.y;
    return resized;
  }

  protected moveFrom(source: Vector, pointer: Point): Vector {
    const moved = super.moveFrom(source, pointer);
    const offset = this.toOffset(Rectangle.from(moved));
    return new Vector(
      new Point(
        moved.from.x + ((moved.from.x < moved.to.x) ? -offset.x : offset.x),
        moved.from.y + ((moved.from.y < moved.to.y) ? -offset.y : offset.y)
      ),
      source.to
    );
  }

  protected moveTo(source: Vector, pointer: Point): Vector {
    const moved = super.moveTo(source, pointer);
    const offset = this.toOffset(Rectangle.from(moved));
    return new Vector(
      source.from,
      new Point(
        moved.to.x + ((moved.from.x < moved.to.x) ? offset.x : -offset.x),
        moved.to.y + ((moved.from.y < moved.to.y) ? offset.y : -offset.y)
      )
    );
  }

  private toOffset(source: Rectangle): Point {
    const configuration = store.state.configuration.behavior.document.editor.grid;
    return new Point(
      -(source.size.width % configuration.width),
      -(source.size.height % configuration.height) 
    );
  }
}
